<template>
  <div class="form-group">
    <label class="control-label">Track time to task</label>
    <AppSelect
      ref="select"
      v-model="selected"
      :select2-options="select2Options"
      :options="options"
      :disabled="disabled"
      :disabled-tooltip="'Select a member to display results'"
    />
  </div>
</template>

<script>
import AppSelect from '../AppSelect.vue';

export default {
  name: 'JobSitesTaskSelect',
  components: { AppSelect },
  props: {
    activeProjectId: Number,
    activeTaskId: Number,
    user: Object,
    options: Array,
  },
  computed: {
    selected: {
      get() {
        return this.activeTaskId;
      },
      set(selectedValue) {
        this.$emit('update-start-task', selectedValue);
      },
    },
    disabled() {
      return !this.user || this.activeProjectId === 0;
    },
    select2Options() {
      return {
        allowClear: true,
        placeholder: 'Select task',
        width: '100%',
        language: {
          noResults: () => 'No tasks assigned to selected user',
        },
        ajax: {
          delay: 250,
          dataType: 'json',
          url: '/tasks/search',
          data: (params) => {
            return {
              project_id: this.activeProjectId,
              user_id: this.user && this.user.id,
              q: params.term,
              page: params.page,
            };
          },
          processResults: function (data) {
            const tasks = data.results.map((task) => ({ id: task.id, text: task.text }));

            return { results: tasks, pagination: data.pagination };
          },
          transport: (params, success, failure) => {
            if (this.disabled) {
              success({ results: [] });

              return false;
            }
            const $request = $.ajax(params);

            $request.then(success);
            $request.fail(failure);

            return $request;
          },
        },
      };
    },
  },
};
</script>
